<template>
  <b-modal :active="value" has-modal-card full-screen @close="close()">
    <!-- 患者選択 -->
    <form style="width: 90%; height: 30px; margin-left: 5%; margin-top: 1%">
      <div class="modal-card" style="width: 100%">
        <section class="modal-card-body" style="width: 100%; height: 100%">
          <selectPatient
            ref="selectedPatient"
            v-bind:select-mode="true"
            v-bind:multi-select-mode="true"
            v-bind:is-nationwide-search="false"
          />
          <div style="height: 10px" />
        </section>

        <footer style="text-align: center">
          <b-button
            v-on:click="close()"
            class="button"
            type="is-primary"
            icon-left="keyboard-backspace"
            native-type="button"
            >戻る</b-button
          >
          <b-button
            v-on:click="select"
            class="button"
            type="is-primary"
            icon-left="content-save"
            native-type="button"
            >選択</b-button
          >
          <div style="height: 10px" />
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import SelectPatientTemplate from "../AppPatientSearch";

export default {
  props: {
    value: {
      type: Boolean,
      defalt: false,
    },
  },

  components: {
    selectPatient: SelectPatientTemplate,
  },

  data() {
    return {};
  },

  computed: {},

  filters: {},

  methods: {
    select: function () {
      let items = this.$refs.selectedPatient.getSelectedItem();
      if (items.length > 0) {
        this.$emit("selected", this.$refs.selectedPatient.getSelectedItem());
        this.close();
      } else {
        this.showErrorMessage("患者情報を選択してください");
      }
    },
    close: function () {
      this.$emit("input", false);
      return;
    },
  },

  created: function () {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/SelectPatient.vue